/* eslint-disable @typescript-eslint/no-unsafe-argument */
import React, { useEffect } from "react";

import { graphql } from "gatsby";

import GasStation from "../../components/pages/GasStations/GasStation";
import useStore from "../../components/pages/GasStations/GasStation/store";

const TankstellePage = ({ pageContext: { gasStation }, data: { page } }) => {
    const { initStore } = useStore();
    const { slug } = gasStation;

    useEffect(() => {
        initStore(slug, gasStation);
    }, [initStore, slug, gasStation]);

    return <GasStation {...{ gasStation, page }} />;
};
export default TankstellePage;

export const query = graphql`
    query {
        page: pageItemsYaml(templateKey: { eq: "pageItems/tankstelle" }) {
            ...PageItem
        }
    }
`;
